import React from "react";

import { Form, FormInstance } from "antd";

import { formatCurrency } from "../../../../../utils";

const { useWatch } = Form;

interface InvoiceAmountDueProps {
  form: FormInstance;
}

export const InvoiceAmountDue: React.FC<InvoiceAmountDueProps> = ({ form }) => {
  const amountDue = useWatch("amountDue", form) || 0;
  const language = useWatch("language", form);
  const currency = useWatch("currency", form);

  const label =
    language === "es"
      ? `Total a Pagar (${currency})`
      : `Amount Due (${currency})`;

  return (
    <div>
      <div className="font-bold text-green-600 mb-1">{label}</div>
      <div className="text-2xl font-bold text-gray-800">
        {formatCurrency(amountDue, currency, language)}
      </div>
    </div>
  );
};
